export type HasMessageType = {
  message: string
}

export const isHasMessage = (error: unknown): error is HasMessageType => {
  return !!(error as HasMessageType).message
}
